import { preparePayload } from 'react-accounting-textfield'

import { changeEventFactory } from '@flecto/utils/src/Window'

export class CurrencyEmiter {
  private initialValue

  private cents = 0

  private float = 0

  private text = ''

  private currency = ''

  constructor(input: string) {
    this.initialValue = input

    try {
      const { cents, float, formatted, value } = preparePayload(
        changeEventFactory(this.initialValue),
        4
      )
      this.cents = cents
      this.float = float
      this.text = value
      this.currency = formatted
    } catch {
      this.cents = 0
      this.float = 0
      this.text = '0,00'
      this.currency = '€0,00'
    }
  }

  get value() {
    return {
      cents: this.cents || 0,
      float: this.float || 0,
      text: this.text || '0,00',
      currency: this.currency || '€0,00',
    }
  }
}

export default CurrencyEmiter
